import { render } from "./OfferSimple.vue?vue&type=template&id=8d0c5646"
import script from "./OfferSimple.vue?vue&type=script&lang=js"
export * from "./OfferSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__